// Copyright 2026, University of Maryland, All Rights Reserved
import { type FC } from 'react'

import type { RendererComponentProps } from '@/app-shell/renderer-components'
import { ClauseList } from '../components/clause-list/ClauseList'
import { resolveClausesForDisplay } from '../hooks/extractors'

export const ClauseAnalysisRenderer: FC<RendererComponentProps> = ({
  documentId,
  orgId,
  workspaceId,
  version,
  slotData = {},
}) => {
  const clausesRes = slotData.clauses ?? null
  const clauses = resolveClausesForDisplay(clausesRes, clausesRes, false)

  const sorted = [...clauses].sort((a, b) => {
    const pageA = a.pageNumber ?? Number.MAX_SAFE_INTEGER
    const pageB = b.pageNumber ?? Number.MAX_SAFE_INTEGER
    return pageA - pageB
  })

  return (
    <div className="flex flex-col gap-6 h-full">
      <ClauseList
        title="Identified Clauses"
        items={sorted}
        countLabel="clause"
        documentId={documentId}
        orgId={orgId}
        workspaceId={workspaceId}
        version={version}
      />
    </div>
  )
}
